export const CAR_RENTALS = "Car Rentals";
export const CHOOSE_YOUR_DATES = "Choose your dates";
export const SELECT_TIME_AND_DRIVER_AGE = "Select Time & Driver Age";
